import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Tucson, AZ?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office in Tucson can take 2–6 months. For Davis-Monthan families with PCS orders, UA students with study-abroad deadlines, and Raytheon engineers with international travel requirements, that timeline is simply not viable.",
  },
  {
    q: "Do I need to drive to Phoenix to get an emergency passport from Tucson?",
    a: "No — that is exactly why Fast Passport Center exists. The nearest regional passport agency to Tucson is in Phoenix, about 120 miles north via I-10. Getting an appointment there is unpredictable and requires taking an entire day away from work or military duties. Fast Passport Center eliminates that trip entirely. You start online, ship your documents overnight, and we handle all agency submission through our reserved courier access.",
  },
  {
    q: "Can Davis-Monthan AFB families get a passport fast for PCS orders?",
    a: "Absolutely. Military families are one of our most common Tucson client types. PCS orders from Davis-Monthan often arrive with 30 days or less to report to assignments overseas. Dependent passports must be current for all family members. We regularly process expedited renewals, new applications, and infant passports for DM families on compressed military timelines — contact us as soon as orders arrive.",
  },
  {
    q: "Can UA students get a passport fast for study abroad?",
    a: "Yes. Study-abroad program deadlines at the University of Arizona often fall in October and February, but many students do not think about their passport until after acceptance. First-time applicants — which many UA students are — require an in-person acceptance clerk visit. We guide UA students through the exact facility location, forms, and timeline so they do not miss their program orientation or departure date. Expedited processing is available for students with confirmed travel.",
  },
  {
    q: "Can Raytheon or L3Harris engineers get an expedited passport for international travel?",
    a: "Yes. Defense industry professionals traveling to international partners in the UK, Australia, Japan, and the Middle East are one of our most common Tucson client groups. International travel requirements on government contracts often arise with 1–2 weeks notice. We accommodate Raytheon, L3Harris, and Sargent Controls travelers regularly — start your order online as soon as you receive your travel authorization.",
  },
  {
    q: "How do I get a passport for cross-border travel from Tucson to Mexico?",
    a: "A U.S. passport (or passport card) is required to return from Mexico via any means of travel — air, land, or sea. Tucson residents traveling to Nogales, Hermosillo, Puerto Pe\u00f1asco, and other Mexican destinations via land border need a passport book or passport card. A passport card is more affordable and wallet-sized, but only valid for land and sea border crossings with Mexico, Canada, Bermuda, and the Caribbean. A passport book is required for international air travel. We can process both expedited.",
  },
  {
    q: "Do I need to visit a Fast Passport Center office in Tucson?",
    a: "No — there is no local Fast Passport Center office in Tucson, and you do not need one. Start your order online from your Tucson home, UA campus apartment, or Marana office. Follow the personalized checklist we send you, and ship your documents overnight from any UPS or FedEx location in the Tucson area. We handle all agency submission remotely through our reserved courier access.",
  },
  {
    q: "What passport acceptance facilities are available in Tucson?",
    a: "Tucson-area residents can visit the Tucson Main Post Office, Tucson Foothills Station Post Office, Marana Post Office, or Green Valley Post Office for passport acceptance clerk services. Most of these require appointments — book ahead, especially during peak travel months. After your clerk visit, ship your sealed envelope overnight to Fast Passport Center for expedited processing. We handle the rest.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability — at lower cost than resellers like FedEx or Staples.",
  },
];

export default function TucsonFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Tucson and Southern Arizona travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}